/* eslint-disable import/prefer-default-export */

export const FeedPreferenceGameLocations = {
    GPS: 'gps',
    PROFILE: 'profile',
};
